import { createSlice } from '@reduxjs/toolkit';

import type { AdvogadoAvulsoState } from '@/types/advogado/advogadoAvulsoTypes';

import { cadastrarAdvogadoAvulso } from './actions';

const initialState: AdvogadoAvulsoState = {
  saving: false,
  error: null,
  success: false,
};

const advogadoAvulsoSlice = createSlice({
  name: 'advogadoAvulso',
  initialState,
  reducers: {
    resetCadastro: (state) => {
      state.saving = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cadastrarAdvogadoAvulso.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.success = false;
      })
      .addCase(cadastrarAdvogadoAvulso.fulfilled, (state) => {
        state.saving = false;
        state.success = true;
      })
      .addCase(cadastrarAdvogadoAvulso.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCadastro } = advogadoAvulsoSlice.actions;
export default advogadoAvulsoSlice.reducer;
